import dayjs from "dayjs"
import { useMemo } from "react"

const defaultConditions: unknown[] = []

/*
 * this hook returns true if any of the provided values have changed since
 * any of the provided conditions
 */
export function useHasChangedSince(
  values: unknown[],
  conditions: unknown[] = defaultConditions,
) {

  const lastChanged = useMemo(
    () => dayjs().toISOString(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    values,
  )


  const firstRendered = useMemo(
    () => dayjs().toISOString(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    conditions,
  )

  const hasChanged = useMemo(
    () => lastChanged > firstRendered,
    [
      firstRendered,
      lastChanged,
    ],
  )

  return hasChanged
}
